module.exports = __webpack_public_path__ + "static/img/logo-bottom.26ac93e.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo-bottom.png
// module id = HeQf
// module chunks = 1